/**
 * Owner: Haselton Baker Risk Group, LLC
 * Copyright All Rights Reserved
 */
// @flow
import type { Element } from 'react';

import React from 'react';
import classNames from 'classnames';
import SelectMenu from '#components/pages/Models/Model/sections/support/forms/SelectMenu/index.js';

const items = [
  { id: 'none', name: 'None', value: 'none' },
  { id: 'moderate', name: 'Moderate', value: 'moderate' },
  { id: 'severe', name: 'Severe', value: 'severe' },
];

type Props = {|
  form: string,
  name: string,
  inputClassName: string,
|};

const DiaphragmDeficiencySelectMenu = ({
  form,
  name,
  inputClassName,
}: Props): Element<typeof SelectMenu> => (
  <SelectMenu
    form={form}
    items={items}
    id={name}
    name={name}
    inputClassName={classNames('custom-select', inputClassName)}
    includeEmptyOption
  />
);

export default DiaphragmDeficiencySelectMenu;
